import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

const integerField = (min: number) =>
  z.coerce
    .number({ message: i18nMessage("validation:required") })
    .int(i18nMessage("validation:invalidNumber"))
    .min(min, i18nMessage("validation:minValue", { min }));

export const PackagePresetSchema = z.object({
  name: z
    .string({ required_error: i18nMessage("validation:required") })
    .trim()
    .min(1, i18nMessage("validation:required")),
  count: integerField(1),
  weight: z.coerce
    .number({ message: i18nMessage("validation:required") })
    .min(1, i18nMessage("validation:minValue", { min: 1 })),
  length: integerField(0),
  width: integerField(0),
  height: integerField(0),
});

export type PackagePresetFormData = z.infer<typeof PackagePresetSchema>;
